import { render, staticRenderFns } from "./UpdateButton.vue?vue&type=template&id=5049bae6&scoped=true"
import script from "./UpdateButton.vue?vue&type=script&lang=ts"
export * from "./UpdateButton.vue?vue&type=script&lang=ts"
import style0 from "./UpdateButton.vue?vue&type=style&index=0&id=5049bae6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5049bae6",
  null
  
)

export default component.exports